import React from 'react';
import jet from "@randajan/jet-core";
import { list } from "@randajan/jet-core/eachSync";

import "./Reviews.scss";
import { Block } from '@randajan/jet-react/dom/block';

import { ReviewShort } from './Review/Review';
import { useBeam } from '@randajan/bifrost/client/react';
import { webReviewsBeam } from '../../../assets/beams/webReviews';
import { Locale } from '../../../assets/Locale';
import { linksBeam } from '../../../assets/beams/linksBeam';
import { WebLink } from '../../../elements/WebLink/WebLink';

export const Reviews = (props) => {
    const { } = props;
    const say = Locale.use()

    const { data: reviews, status } = useBeam(webReviewsBeam);
    const { data: links } = useBeam(linksBeam);

    return (
        <Block className="Reviews slab wall -dark -border" caption={say("reviewsCaption")} data-status={status}>
            <div className="scene">
                <div className="carousel">
                    {reviews?.map((rew, key) => <ReviewShort key={key} review={rew} maxLength={150} />)}
                </div>
            </div>
            <Block className="reviewsAdd" caption={say("reviewsAdd")}>
                <div className="reviewsLinks">
                    {links?.filter(r => r.category === "reviews").map((link, key) => <WebLink key={key} link={link}/>)}
                </div>
            </Block>
        </Block>
    )
}

